import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import _pub2Dbb4493 from "./Button.pc";
import "./BlankSlate.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_3ebf16d6 _8a05fd1a _pub-8a05fd1a _pub-a97d53f3" + " " + "_8a05fd1a_v3 _pub-8a05fd1a_v3 _pub-a97d53f3_v3 v3",
    "ref": ref,
  }, 
    React.createElement("div", {
      "className": "_139ba15d _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
    }, 
      props["illustration"]&&React.createElement("div", {
        "className": "_9bf5412b _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
      }, 
        props["illustration"]
      ),
      React.createElement("div", {
        "className": "_7e0ba6c _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
      }, 
        props["title"]
      ),
      React.createElement("div", {
        "className": "_70e78afa _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
      }, 
        props["description"]
      ),
      React.createElement("div", {
        "className": "_99842fcf _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
      }, 
        props["controls"]
      )
    )
  )
}));
export default $$Default;

var BlankSlatePreview = React.memo(React.forwardRef(function BlankSlatePreview(props, ref) {
  return React.createElement(_pubBab5A68F_Preview, {
    "class": "_d0b177fa _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
    "ref": ref,
  }, 
    React.createElement($$Default, {
      "class": "_671845a5",
      "title": "Blank Slate",
      "description": "Some description of what to do",
      "controls": React.createElement(React.Fragment, {
      }, 
        React.createElement(_pub2Dbb4493, {
          "class": "_9f8c3e55 _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
          "primary": true,
        }, 
          "Control"
          
        ),
        React.createElement(_pub2Dbb4493, {
          "class": "_e88b0ec3 _8a05fd1a _pub-8a05fd1a _pub-a97d53f3",
          "secondary": true,
        }, 
          "Control 2"
          
        )
      ),
    }, null)
  )
}));
export { BlankSlatePreview };


